import { render, staticRenderFns } from "./WhiteLists.vue?vue&type=template&id=194e32f7&scoped=true"
import script from "./WhiteLists.vue?vue&type=script&lang=js"
export * from "./WhiteLists.vue?vue&type=script&lang=js"
import style0 from "./WhiteLists.vue?vue&type=style&index=0&id=194e32f7&prod&lang=scss&scoped=true"
import style1 from "./WhiteLists.vue?vue&type=style&index=1&id=194e32f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e32f7",
  null
  
)

export default component.exports